<template>
  <Row>
        <i-col span="12">
                  <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
            <FormItem label="权限名称" prop="name">
                <i-input v-model="formValidate.name" placeholder="请输入权限名称"></i-input>
            </FormItem>
            <FormItem label="权限等级" prop="type">
              <Select v-model="formValidate.type" style="width:260px">
                <Option v-for="item in privilegetype" :value="item.type" :key="item.type">{{ item.value }}</Option>
             </Select>
            </FormItem>
            <FormItem label="权限描述" prop="description">
                <i-input v-model="formValidate.description" placeholder="请输入权限描述"></i-input>
            </FormItem>
                <FormItem label="菜单">
                  <Select v-model="menu.lev1" style="width:100px" @on-change="changedata()">
                    <Option v-for="item in menudata" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                  <Select v-model="menu.lev2" style="width:100px" @on-change="changedatb" v-if="isshow">
                    <Option v-for="item in menudata[myindex].submenu" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                <Select v-model="menu.lev3" style="width:100px" @on-change="changedatc" v-if="isshow1">
                    <Option v-for="item in submenu" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
                 <Button type="primary" @click="menuinit()">重置</Button>  
             </FormItem>
             <FormItem label="权限按钮" prop="button_id" v-if="formValidate.type==1">
                    <i-input v-model="formValidate.button_id" placeholder="请输入权限按钮"></i-input>
             </FormItem>
              <FormItem label="控制器名" prop="control">
                    <i-input v-model="formValidate.control" placeholder="请输入控制器名"></i-input>
             </FormItem>
             <FormItem label="方法名" prop="action">
                    <i-input v-model="formValidate.action" placeholder="请输入方法名"></i-input>
             </FormItem> 
            <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
            </FormItem>
        </Form>
        </i-col>
    </Row>    
</template>
<script>
import { mapState } from "vuex";
import { updateprivileges } from "../../api/privilegesapi";
import constantdata from "../../constant/index";
export default {
  data() {
    const validatemenu_id = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择菜单"));
      } else {
        callback();
      }
    };
    const validatetype = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择权限类型"));
      } else {
        callback();
      }
    };
    return {
      params: this.$route.params,
      privilegetype: constantdata.privilegetype,
      formValidate: {
        type: "",
        name: "",
        description: "",
        control: "",
        action: "",
        menu_id: "",
        button_id: ""
      },
      myindex: 0,
      isshow: false,
      isshow1: false,
      submenu: [],
      menu: {
        lev1: null,
        lev2: null,
        lev3: null
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "请输入权限名称",
            trigger: "blur"
          }
        ],
        menu_id: [{ validator: validatemenu_id, trigger: "blur" }],
        type: [
          {
            validator: validatetype,
            message: "请选择权限类型",
            trigger: "change"
          }
        ],
        button_id: [
          {
            required: true,
            message: "请输入权限按钮",
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: mapState({
    roleList: state => state.roleList,
    menudata: state => state.menulist
  }),
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.update();
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    update() {
      let para = this.formValidate;
      if (this.menu.lev1) {
        para.menu_id = this.menu.lev1;
        if (this.menu.lev2) {
          para.menu_id = this.menu.lev2;
          if (this.menu.lev3) {
            para.menu_id = this.menu.lev3;
          }
        }
      }
      this.$Loading.start();
      para.id = this.$route.query.id;
      updateprivileges(para).then(res => {
        this.$Loading.finish();
        var data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
          this.$router.push({ path: "/platformlist" });
        } else {
          this.$Message.error(data.message);
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    passwdCheck() {
      if (this.formValidate.password != "") {
        return true;
      } else {
        return false;
      }
    },
    changedata() {
      this.menudata.forEach((element, index) => {
        if (element.id == this.menu.lev1) {
          this.myindex = index;
          if (element.submenu && element.submenu.length > 0) {
            this.isshow = true;
          } else {
            this.isshow = false;
          }
        }
      });
       if(this.menu.lev2){
         this.changedatb()
      }
    },
    changedatb() {
      var data = this.menudata[this.myindex].submenu;
      data.forEach((element, index) => {
        if (element.id == this.menu.lev2) {
          if (element.submenu && element.submenu.length > 0) {
            this.isshow1 = true;
            this.submenu = element.submenu;
          } else {
            this.isshow1 = false;
          }
        }
      });
     
    },
    menuinit() {
      this.formValidate.menu_id = null;
      this.isshow = false;
      this.isshow1 = false;
      this.menu.lev1 = null;
      this.menu.lev2 = null;
      this.menu.lev3 = null;
    },
    setinit(params) {
      this.formValidate = {
        type: params.type,
        name: params.name,
        description: params.description,
        control: params.control,
        action: params.action,
        menu_id: params.menu_id,
        button_id: params.button_id
      };
      this.getmenu(Number(params.menu_id));
    },
    //三级联动数据绑定
    getmenu(id) {
      var data = this.menudata;
      data.forEach((element, ind) => {
        if (element.id == id) {
          this.menu.lev1 = id;
        } else {
          if (element.submenu && element.submenu.length > 0) {
            element.submenu.forEach((item, i) => {
              if (item.id == id) {
                this.menu.lev1 = element.id;
                this.menu.lev2 = id;
                this.myindex = ind;
                this.isshow = true;
              } else {
                if (item.submenu && item.submenu.length > 0) {
                  item.submenu.forEach(value => {
                    if (value.id == id) {
                      this.menu.lev3 = id;
                      this.menu.lev1 = element.id;
                      this.menu.lev2 = item.id;
                      this.submenu = item.submenu;
                      this.myindex = ind;
                      this.isshow = true;
                      this.isshow1 = true;
                    }
                  });
                }
              }
            });
          }
        }
      });
    }
  },
  mounted() {
    if (this.$route && this.$route.query) {
      this.setinit(this.$route.query);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/privileges/platformupdte.vue